export default "__VITE_ASSET__9QEQXas7__"